import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';

export interface ColorsStepHandle {
  isValid: () => boolean;
  getPartialDraft: () => { color1: string; color2: string; color3: string };
  focusFirstInvalid: () => void;
}

interface ColorsStepProps {
  initial: { color1: string; color2: string; color3: string };
  onChange?: (partial: { color1?: string; color2?: string; color3?: string }) => void;
}

const HEX_RE = /^#([0-9a-fA-F]{6})$/;

const ColorsStep = forwardRef<ColorsStepHandle, ColorsStepProps>(({ initial, onChange }, ref) => {
  const [color1, setColor1] = useState(initial.color1);
  const [color2, setColor2] = useState(initial.color2);
  const [color3, setColor3] = useState(initial.color3);

  const input1Ref = useRef<HTMLInputElement>(null);
  const input2Ref = useRef<HTMLInputElement>(null);
  const input3Ref = useRef<HTMLInputElement>(null);

  const isValid = () => HEX_RE.test(color1) && HEX_RE.test(color2) && HEX_RE.test(color3);

  const focusFirstInvalid = () => {
    if (!HEX_RE.test(color1)) { input1Ref.current?.focus(); return; }
    if (!HEX_RE.test(color2)) { input2Ref.current?.focus(); return; }
    if (!HEX_RE.test(color3)) { input3Ref.current?.focus(); }
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getPartialDraft: () => ({ color1, color2, color3 }),
    focusFirstInvalid,
  }), [color1, color2, color3]);

  return (
    <div>
      <h3 className="mb-4 text-lg font-semibold text-gray-800">Couleurs de l'entreprise</h3>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">Couleur principale</label>
          <div className="flex items-center gap-3">
            <input ref={input1Ref} type="color" value={color1} onChange={(e) => { const v = e.target.value; setColor1(v); if (onChange) { onChange({ color1: v }); } }} className="h-10 w-10 rounded" />
            <input type="text" value={color1} onChange={(e) => { const v = e.target.value; setColor1(v); if (onChange) { onChange({ color1: v }); } }} className={`w-28 rounded border p-2 ${HEX_RE.test(color1) ? 'border-gray-300' : 'border-red-400'}`} />
          </div>
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">Couleur secondaire</label>
          <div className="flex items-center gap-3">
            <input ref={input2Ref} type="color" value={color2} onChange={(e) => { const v = e.target.value; setColor2(v); if (onChange) { onChange({ color2: v }); } }} className="h-10 w-10 rounded" />
            <input type="text" value={color2} onChange={(e) => { const v = e.target.value; setColor2(v); if (onChange) { onChange({ color2: v }); } }} className={`w-28 rounded border p-2 ${HEX_RE.test(color2) ? 'border-gray-300' : 'border-red-400'}`} />
          </div>
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">Couleur accent</label>
          <div className="flex items-center gap-3">
            <input ref={input3Ref} type="color" value={color3} onChange={(e) => { const v = e.target.value; setColor3(v); if (onChange) { onChange({ color3: v }); } }} className="h-10 w-10 rounded" />
            <input type="text" value={color3} onChange={(e) => { const v = e.target.value; setColor3(v); if (onChange) { onChange({ color3: v }); } }} className={`w-28 rounded border p-2 ${HEX_RE.test(color3) ? 'border-gray-300' : 'border-red-400'}`} />
          </div>
        </div>
      </div>
    </div>
  );
});

ColorsStep.displayName = 'ColorsStep';

export default ColorsStep;


